var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<div>\n  <div id=\"map\"></div>\n  <div class=\"flex\">\n    <div ng-class=\"{ empty: ! position }\" class=\"new-address\">\n      <div animate-on-change=\"position\">\n        &nbsp;\n        {{ newAddress }}\n        <div>{{ position.lat() | number:6 }}&nbsp; {{ position.lng() | number:6 }}</div>\n      </div>\n    </div>\n    <button ng-disabled=\"! position\" ng-click=\"save()\" class=\"action\">Bruk koordinater</button>\n  </div>\n</div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/html/templates/mapCoordinates.jade
 ** module id = 87
 ** module chunks = 1
 **/